module.exports = __webpack_public_path__ + "preloader.empty.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/preloader/preloader.empty.png
// module id = 1247
// module chunks = 8